module.exports = __webpack_public_path__ + "static/media/PencilIcon.91031452.svg";